/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-11-28 18:17:15
 * @modify date 2023-11-28 18:17:15
 * @desc [description]
 */

import i18n from "../../../lang/base";
import SmtpMgmtUpdate from "./SmtpMgmtUpdate";



export interface SmtpMgmtData {
  smtp_sender_address: string;
  smtp_sender_name: string;
  smtp_prefix: string;
  smtp_host: string;
  smtp_port: string;
  smtp_username: string;
  smtp_tls_yn: boolean;
  support_manager: string;
  update_ts: string;
}

export const initSmtpMgmtData = {
  smtp_sender_address: "",
  smtp_sender_name: "",
  smtp_prefix: "",
  smtp_host: "",
  smtp_port: "",
  smtp_username: "",
  present_alert_severity_code: "",
  smtp_tls_yn: false,
  support_manager: "",
  update_ts: "",
}



export const smtpMgmtUpdateModalContents = {
  title: i18n.t("MENU_APPLICATION_SMTP_UPDATE_TITLE"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <SmtpMgmtUpdate/>
}